import React, { useState, useEffect } from "react";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL 
  
const CurrentOccupationCard = () => {
  const [occupations, setOccupations] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/main-occupation`)
      .then((response) => {
        const res = response.data;
        if (res.success && Array.isArray(res.occupation)) {
          setOccupations(res.occupation);
        }
      })
      .catch((error) =>
        console.error("Error fetching main occupation:", error)
      );
  }, []);

  return (
    <div className="bg-white p-10 rounded-2xl shadow-sm w-full border border-gray-100 mt-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-10">
        Current Occupation
      </h2>

      {occupations.length > 0 ? (
        <div className="space-y-8">
          {occupations.map((item, index) => (
            <div key={index} className="flex flex-col gap-2">
              <span className="text-[#1f4d36] text-lg font-semibold">
                {item.label}
              </span>

              <div className="flex items-center gap-6">
                <div className="flex-1 h-3 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#c21807] rounded-full transition-all duration-1000 ease-out"
                    style={{ width: `${item.percent}%` }}
                  ></div>
                </div>

                <span className="text-gray-500 text-lg font-medium min-w-[60px] text-right">
                  {item.percent}%
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">No occupation data yet.</p>
      )}
    </div>
  );
};

export default CurrentOccupationCard;
